import { render, staticRenderFns } from "./PackageCompTest.vue?vue&type=template&id=4a9444c1&scoped=true"
import script from "./PackageCompTest.vue?vue&type=script&lang=js"
export * from "./PackageCompTest.vue?vue&type=script&lang=js"
import style0 from "./PackageCompTest.vue?vue&type=style&index=0&id=4a9444c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9444c1",
  null
  
)

export default component.exports